export const cars = {
  // Search
  searchCars: 'البحث عن السيارات',
  searchCarsDescription: 'ابحث عن السيارة المثالية لرحلتك',
  location: 'الموقع',
  selectLocation: 'اختر الموقع',
  checkInDate: 'تاريخ الاستلام',
  checkOutDate: 'تاريخ الإرجاع',
  selectDate: 'اختر التاريخ',
  searchNow: 'ابحث الآن',
  clearAll: 'مسح الكل',
  optionalDates: 'اختياري: أضف التواريخ للحصول على نتائج أفضل',
  checkIn: 'الاستلام',
  checkOut: 'الإرجاع',
  whereGoing: 'إلى أين أنت ذاهب؟',
  whenTrip: 'متى رحلتك؟',
  quickSelect: 'اختيار سريع',
  threeDays: '3 أيام',
  oneWeek: 'أسبوع واحد',
  twoWeeks: 'أسبوعان',
  search: 'بحث',
  
  // Cars page
  availableCars: 'السيارات المتاحة',
  carsCount: '{{count}} سيارة متاحة',
  carsCount_other: '{{count}} سيارة متاحة',
  noCarsAvailable: 'لا توجد سيارات متاحة في الوقت الحالي.',
  imageNotAvailable: 'الصورة غير متاحة',
  seats: 'مقاعد',
  automatic: 'أوتوماتيك',
  manual: 'يدوي',
  others: 'أخرى',
  perDay: '/يوم',
  book: 'احجز',
  available: 'متاح',
  currency: 'درهم',
  notAvailable: 'غير متاح',
  insured: 'مؤمن',
  
  // Error handling
  error: 'خطأ',
  retry: 'حاول مرة أخرى',
  loadingCars: 'جاري تحميل السيارات...',
  
  // Car listing page
  findPerfectCar: 'اعثر على السيارة المثالية لرحلتك القادمة',
  searchByMakeModel: 'البحث بالماركة أو الطراز',
  allCategories: 'جميع الفئات',
  allTransmissions: 'جميع أنواع النقل',
  anySeats: 'أي عدد مقاعد',
  clearFilters: 'مسح المرشحات',
  carsFound: 'سيارة موجودة',
  noCarsFound: 'لم يتم العثور على سيارات',
  adjustSearchCriteria: 'حاول تعديل معايير البحث أو امسح المرشحات لرؤية المزيد من النتائج.',
  more: 'المزيد',
  filters: 'المرشحات',
  category: 'الفئة',
  transmission: 'ناقل الحركة',
  priceRange: 'نطاق السعر (درهم)',
  minPrice: 'الحد الأدنى',
  maxPrice: 'الحد الأقصى',
  filtered: 'نتائج مفلترة',
  
  // Enhanced filters
  allBrands: 'جميع الماركات',
  searchBrands: 'البحث عن الماركات...',
  noBrandsFound: 'لم يتم العثور على ماركات.',
  allModels: 'جميع النماذج',
  selectBrandFirst: 'اختر ماركة',
  
  // Car details
  viewDetails: 'عرض التفاصيل',
  specifications: 'المواصفات',
  featuresTab: 'المميزات',
  moreFeatures: 'مميزات أخرى',
  noFeatures: 'لا توجد مميزات متاحة',
  description: 'الوصف',
  gallery: 'المعرض',
  
  // Booking
  selectCar: 'اختر السيارة',
  bookNow: 'احجز الآن',
  reserveNow: 'احجز الآن',
  pricePerDay: 'في اليوم',
  
  // Reviews
  reviews: 'التقييمات',
  writeReview: 'اكتب تقييم',
  rating: 'التقييم',
  
  // Car Details Page
  rentalAgency: 'وكالة الإيجار',
  bookThisCar: 'احجز هذه السيارة',
  locationDetails: 'أماكن الاستلام والإرجاع',
  dateTimeDetails: 'التواريخ والأوقات',
  additionalDetails: 'معلومات إضافية',
  pickupLocation: 'مكان الاستلام',
  dropoffLocation: 'مكان الإرجاع',
  pickupTime: 'وقت الاستلام',
  returnTime: 'وقت الإرجاع',
  day: 'يوم',
  days: 'أيام',
  additionalNotes: 'ملاحظات إضافية',
  additionalNotesPlaceholder: 'أدخل أي ملاحظات إضافية...',
  dailyRate: 'السعر اليومي',
  duration: 'المدة',
  total: 'المجموع',
  processing: 'جاري المعالجة...',
  needToSignIn: 'تحتاج إلى تسجيل الدخول',
  toBookThisCar: 'لحجز هذه السيارة',
  fuel: 'الوقود',
  
  // Agency Details
  agencyDetails: {
    title: 'تفاصيل الوكالة',
    description: 'صفحة تفاصيل الوكالة للمعرف: {{id}} قيد التطوير.',
  },
  
  // Agency filtering
  filterByAgency: 'تصفية حسب الوكالة',
  browsingAgencyCars: 'تصفح السيارات من {{agency}}',
  agencyNotFound: 'الوكالة غير موجودة',
  
  // Booking features
  features: {
    cancelAnytime: 'إلغاء مجاني',
    instantConfirmation: 'تأكيد فوري',
    flexibleTiming: 'مواعيد مرنة 8ص-10م',
    premiumSupport: 'دعم عملاء مميز 24/7',
    multipleLocations: 'استلام من مدن متعددة'
  },

  // Search Panel
  pickupDropoff: 'الاستلام / الإرجاع',
  searchLocation: 'البحث عن موقع...',
  noLocationFound: 'لم يتم العثور على موقع.',
  agency: 'الوكالة',
  dates: 'التواريخ',
  pickDate: 'اختر التاريخ',
  notesPlaceholder: 'أي طلبات خاصة أو ملاحظات...',
  changeLocation: 'تغيير الموقع',
  totalPrice: 'السعر الإجمالي',
  selectPickupLocation: 'اختر موقع الاستلام',
  selectDropoffLocation: 'اختر موقع الإرجاع',
  select: 'اختر',
  openInMap: 'فتح في الخريطة',
  bookingSuccess: 'تم الحجز بنجاح!',
  bookingCreatedSuccessfully: 'تم إنشاء حجزك بنجاح!',
  agencyWillContact: 'ستتواصل معك الوكالة عبر واتساب لتأكيد حجزك.',
  keepPhoneAvailable: 'يرجى إبقاء هاتفك متاحاً.',
  trackInDashboard: 'يمكنك تتبع حجزك في لوحة التحكم الخاصة بك',
  goToDashboard: 'الذهاب إلى لوحة التحكم',
  
  // Category browsing
  browseByCategory: 'تصفح حسب الفئة',
  browsingCategoryDescription: 'تصفح مجموعتنا من',
  
  // Availability status
  availabilityStatus: 'التوفر',
  allStatuses: 'جميع الحالات',
  availableStatus: 'متاح',
  rented: 'مؤجر',
  maintenance: 'صيانة',
  unavailable: 'غير متاح',
  showAll: 'عرض الكل',
  availableOnly: 'المتاح فقط',
  availableOnlySelectedDates: 'المتاح فقط في التواريخ المحددة',
  availableOnlyToday: 'المتاح فقط اليوم',
  applyFilters: 'تطبيق المرشحات',
  nameAZ: 'الاسم: أ-ي',
  
  // Sort options
  sortBy: 'ترتيب حسب',
  relevant: 'ذو الصلة',
  newest: 'الأحدث',
  priceLowHigh: 'السعر: من الأقل إلى الأعلى',
  priceHighLow: 'السعر: من الأعلى إلى الأقل',
  yearNewest: 'السنة: الأحدث',
  
  // Related cars
  otherCarsSameCategory: 'سيارات أخرى في نفس الفئة',
  otherCarsSameCity: 'سيارات أخرى في نفس المدينة',
  loadingRelatedCars: 'جاري تحميل السيارات المشابهة...',
  noRelatedCars: 'لم يتم العثور على سيارات مشابهة'
}; 